import styled from '@emotion/styled';
import { Divider, Flex, Icon, Link, Paper, Text } from 'common/styles';
import { IconAngleLeft, IconEmail, IconFaq, IconPhone } from 'common/icons';
import { __t } from 'common/i18n';
import { paperBg } from './styles/Paper';
import { ReactNode } from 'react';

const ContactUsInfo = ({ faq, IconColor }: { faq?: boolean, IconColor: string }) => (
  <Container direction={{ xs: 'column', md: 'column' }} mt={6}>
    <Flex direction={{ xs: 'column', md: 'row' }}>    {faq && (
      <InfoGroup icon={<IconFaq currentColor={IconColor} />} title="common.faq" description="static.faq.cta" divider>
        <Text variant="body2" weight="light">
          <Link href="/faq" mt={2}>{__t('static.faq.link')} <Icon cursor="pointer"><IconAngleLeft /></Icon></Link>
        </Text>
      </InfoGroup>
    )}
    <InfoGroup icon={<IconEmail currentColor={IconColor} />} title="contact.us.send_email" description="contact.us.respond_message" divider>
      <Text variant="body2" weight="light">
        <Link href={`mailto:${__t('contact.us.email')}`} mt={2}>{__t('contact.us.email')}</Link>
      </Text>
    </InfoGroup>
    <InfoGroup title="contact.us.call_to_support" icon={<IconPhone currentColor={IconColor} />} description="contact.us.support_timespan" extraDesc="contact.us.extra_support_timespan">
      <Text variant="body2" weight="light">
        {/* <Link href={`tel:${__t('contact.us.area_code')}${__t('contact.us.phone2')}`}>{__t('contact.us.area_code')}-{__t('contact.us.phone2')} */}
        {/* </Link> */}
        {/*     &nbsp; / &nbsp; */}
        <Link
          href={`tel:${__t('contact.us.area_code')}${__t('contact.us.phone1')}`} mt={2}>{__t('contact.us.area_code')}-{__t('contact.us.phone1')}
        </Link>
      </Text>
    </InfoGroup>
    </Flex>
    <DividerWrapper px={3} >
      <Divider my={{ xs: 6, md: 3 }} />
    </DividerWrapper>
    <Flex direction={'column'} px={3} mb={3} as={Paper}>
      <Text variant="body1" mb={1}>{__t('contact.us.address')}</Text>
      <Text variant="body2" color="weak" mb={1}>{__t('contact.us.full.address')}</Text>
      <Text variant="body2" color="weak" mb={1}>{__t('contact.us.full.postal.code')}</Text>
    </Flex>
  </Container>
);

interface InfoGroupProps {
  children: ReactNode;
  icon: ReactNode;
  title: string;
  description: string;
  divider?: boolean;
  extraDesc?: string;
}

const InfoGroup = ({ children, icon, title, description, divider, extraDesc }: InfoGroupProps) => (
  <>
    {/* <Flex as={Paper} direction="column" py={4} px={3} mb={{ xs: 4, md: 0 }}> */}
    <Section as={Paper}>
      <Icon size="large" mb={2}>{icon}</Icon>
      <Text variant="body1" mb={2}>{__t(title)}</Text>
      <Text variant="body3" color="weak" mt={2} mb={1}>{__t(description)}</Text>
      <br/>
      {extraDesc && <Text variant="body3" color="weak">{__t(extraDesc)}</Text>}
      {children}
    </Section>
    {/* </Flex> */}
    {divider && <VerticalDivider className="desktop-only" my={4} />}
  </>
);

const Section = styled('div')(() => ({
  padding: '2rem 1.5rem 0.5rem',
  '@media(max-width: 850px)': {
    marginBottom: '2rem',
  },
}));

const VerticalDivider = styled(Divider)(() => ({
  border: 'none',
  borderRight: '1px solid',
}));

const Container = styled(Flex)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    backgroundColor: theme.palette.background[paperBg.main][0],
    borderRadius: theme.radius.default,
    [`${Flex}`]: {
      flexGrow: 1,
    },
  },
}));

const DividerWrapper = styled(Flex)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

export default ContactUsInfo;
